import { AppName } from '../app-name/app-name';

export function getPdfWorkerPath(): string | undefined {
    const appName = (process.env.APP_NAME ?? 'cad') as AppName;
    const isProduction = process.env.NODE_ENV === 'production';
    const version = process.env.APP_VERSION;

    const basePath = appName === 'first-responder' ? 'first-responder-next' : 'cad-next';
    let workerPath: string | undefined;
    // the pdf.worker.min.js file copied/created via copy-pdf-worker-plugin. The path and file name should match whatever is in the
    // vite.config.base.ts
    if (isProduction && version) {
        // Production with versioned assets
        workerPath = `/${basePath}/${version}/pdf.worker.min.js`;
    } else if (!isProduction) {
        // Development mode
        workerPath = `/${basePath}/pdf.worker.min.js`;
    }
    // Unable to determine PDF worker path in unexpected configuration

    return workerPath;
}
